
export const formatPermissionsForApi = (securityGroup) => {
    let permissions = securityGroup.permissions;
    let apiPermissions = {};
    for (let permissionId in permissions) {
        let { fields, scopeId, officeIds } = permissions[permissionId];
        apiPermissions[permissionId] = { fields, scopeId, officeIds };
    }
    securityGroup.permissions = apiPermissions;
};

export const getUsersForTable = (users, _users) => {
    return _users.filter(_user => isUserInSecurityGroup(users, _user.id));
};

export const isUserInSecurityGroup = (securityGroupUsers, userId) => {
    return securityGroupUsers.some(user => user.userId === userId);
};